const allowedExternalProtocols =
  new Set([
    "http:",
    "https:"
  ]);


const allowedRichTextProtocols =
  new Set([
    "http:",
    "https:",
    "mailto:",
    "tel:"
  ]);


export const getSafeExternalUrl = (
  value
) => {

  if (typeof value !== "string") {
    return "";
  }

  const trimmed =
    value.trim();

  if (!trimmed) {
    return "";
  }

  try {

    const parsed =
      new URL(trimmed);

    if (
      !allowedExternalProtocols.has(
        parsed.protocol
      )
    ) {
      return "";
    }

    return trimmed;

  } catch {

    return "";

  }

};


export const getSafeRichTextUrl = (
  value
) => {

  if (typeof value !== "string") {
    return "";
  }

  const trimmed =
    value.trim();

  if (!trimmed) {
    return "";
  }


  /*
   * Allow internal site paths.
   */
  if (
    trimmed.startsWith("/") &&
    !trimmed.startsWith("//")
  ) {
    return trimmed;
  }


  /*
   * Allow same-document anchors.
   */
  if (trimmed.startsWith("#")) {
    return trimmed;
  }


  try {

    const parsed =
      new URL(trimmed);

    if (
      !allowedRichTextProtocols.has(
        parsed.protocol
      )
    ) {
      return "";
    }

    return trimmed;

  } catch {

    return "";

  }

};